import React, { FC, useCallback, useContext } from "react";
import { INotification } from "../../../../common/interfaces/notifications.interface";
import "./NotificationItem.scss";
import { parseDateToRelativeTime } from "../../../../solana/common/helpers/common.helpers";
import { UserContext } from "../../../../contexts/userContext";
import { SummaryTabIdentifiers } from "../../../../common/enums/club.enum";
import { useNavigate } from "react-router";
import clubAvatar from "../../../../assets/clubAvatar.png";
import { CLUB_DETAILS } from "../../../../common/constants/routes.constants";
import { EMPTY_STRING } from "../../../../common/constants/common.constants";
import {
  getAllNotifications,
  toggleNotification,
} from "../../../../api/notifications.api";
import { NotificationTypeLabel } from "../../../../common/enums/notification.enum";
import { useWallet } from "@solana/wallet-adapter-react";

const NotificationItem: FC<{ notification: INotification }> = ({
  notification,
}) => {
  const { notifications, setNotifications, toggleNotificationsModal, isXnft } =
    useContext(UserContext);
  const navigate = useNavigate();

  const wallet = useWallet();

  const markNotificationAsRead = useCallback(
    async (e) => {
      e.stopPropagation();
      if (!notification) return;
      try {
        await toggleNotification(notification.userNotId);
        const notifications = await getAllNotifications(
          wallet.publicKey!.toString()
        );
        setNotifications(notifications);
      } catch (error) {
        console.log(error);
      }
    },
    [notifications]
  );

  const openClubDetails = useCallback(
    async (
      clubAddress: string,
      tab?: SummaryTabIdentifiers,
      proposalAddress?: string
    ) => {
      toggleNotificationsModal(false);
      try {
        if (!notification.hasRead) {
          await toggleNotification(notification.userNotId);
        }
        const notifications = await getAllNotifications(
          wallet.publicKey!.toString()
        );
        setNotifications(notifications);
      } catch (error) {
        console.log(error);
      }
      if (proposalAddress && tab === SummaryTabIdentifiers.proposals) {
        navigate(`${CLUB_DETAILS}/${clubAddress}?proposal=${proposalAddress}`);
        return;
      } else if (tab) {
        navigate(`${CLUB_DETAILS}/${clubAddress}?tab=${tab}`);
        return;
      }
      navigate(`${CLUB_DETAILS}/${clubAddress}`);
    },
    [notifications]
  );

  return (
    <div
      onClick={() =>
        !isXnft &&
        openClubDetails(
          notification.clubAddress,
          notification?.tab,
          notification?.proposalAddress
        )
      }
      className="notification-item"
    >
      <div>
        <div className="notification-item__img-wrapper">
          <img
            src={
              notification.imageUrl !== EMPTY_STRING
                ? notification.imageUrl
                : clubAvatar
            }
            alt="img"
          />
        </div>
        <div className="notification-item__title-wrapper">
          <p className="notification-item__type">
            {NotificationTypeLabel[notification.notificationType]}
          </p>
          <div className="notification-item__time-title">
            <p
              dangerouslySetInnerHTML={{ __html: notification.message }}
              className="notification-item__title"
            ></p>

            <p className="notification-item__time">
              {parseDateToRelativeTime(notification.createdAt)}
            </p>
          </div>
        </div>
      </div>
      <span
        onClick={(e) => markNotificationAsRead(e)}
        className={`notification-item__check ${
          !notification.hasRead
            ? "notification-item__check--green"
            : "notification-item__check--transparent"
        }`}
      />
    </div>
  );
};

export default NotificationItem;
